import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';

export interface QpWindow {
  has_qp: boolean;
  side: 'buy' | 'sell' | null;
  // Resolved banner label (e.g. "Feb 2026 Monthly Average").
  label: string;
  // Anchor formula (e.g. "ETA_DATE +0d / ETA_DATE +30d") for the date-less
  // dialog warning, matching Launchpad.
  formula_label: string | null;
  concluded: boolean;
  invoicing_available_date: string | null;
}

export function qpWindowKey(blOrderId: string | undefined) {
  return ['bl-order-qp-window', blOrderId] as const;
}

// BL-level QP window (sell ticket preferred, else buy). Display-only — it never
// gates invoice creation.
export function useQpWindow(blOrderId: string | undefined) {
  return useQuery<QpWindow>({
    queryKey: qpWindowKey(blOrderId),
    enabled: blOrderId !== undefined && blOrderId.length > 0,
    queryFn: () =>
      apiRequest<QpWindow>(`/bl-orders/${encodeURIComponent(blOrderId ?? '')}/qp-window`),
  });
}
